import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { formatPageTitle } from './page-title';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.getRouteTitle(snapshot.root);

    if (!routeTitle) {
      return;
    }

    this.title.setTitle(formatPageTitle(routeTitle));
  }

  private getRouteTitle(route: ActivatedRouteSnapshot): string | null {
    let currentRoute: ActivatedRouteSnapshot | null = route;
    let matchedTitle: string | null = null;

    while (currentRoute) {
      const nextTitle = currentRoute.title ?? currentRoute.data?.['title'];
      if (typeof nextTitle === 'string' && nextTitle.trim().length > 0) {
        matchedTitle = nextTitle.trim();
      }

      currentRoute = currentRoute.firstChild ?? null;
    }

    return matchedTitle;
  }
}
